exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-templates-event-page-tsx": () => import("./../../../src/templates/EventPage.tsx" /* webpackChunkName: "component---src-templates-event-page-tsx" */),
  "component---src-templates-regular-page-tsx": () => import("./../../../src/templates/RegularPage.tsx" /* webpackChunkName: "component---src-templates-regular-page-tsx" */)
}

